import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Container, Image, Table } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
import Switch from "react-switch";
import {
  admin_delete_chain_catalog,
  admin_delete_global_catalog,
  admin_get_chain_catalog,
  admin_get_global_catalog,
  admin_update_chain_catalog,
  admin_update_global_catalog,
} from "../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import {
  EDIT_CHAIN_CATALOG,
  EDIT_GLOBAL_CATALOG,
} from "../../../../store/types";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { ChainTablesBody, ChainTablesHead } from "./ChainTables";
import FilterSection from "./FilterSection";
import GlobalCatalogViewDetails, {
  GlobalCatalogDeletePopUp,
} from "./GlobalCatalogViewDetails";

const GlobalCatalogueDashboard = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [state, setState] = useState(1);

  const onSuccess = () => {
    const token = props.auth.user.accessToken;
    props.admin_get_global_catalog(token);
    props.admin_get_chain_catalog(token);
  };

  const onChangeGlobalStatus = (status, id) => {
    let formData = {};
    formData.status = !status;
    const token = props.auth.user.accessToken;
    props.admin_update_global_catalog(token, formData, id, onSuccess);
  };

  const onChangeChainStatus = (status, id) => {
    let formData = {};
    formData.status = !status;
    const token = props.auth.user.accessToken;
    props.admin_update_chain_catalog(token, formData, id, onSuccess);
  };

  const deleteGlobalCatalog = (id) => {
    const token = props.auth.user.accessToken;
    props.admin_delete_global_catalog(token, id, onSuccess);
  };

  const deleteChainCatalog = (id) => {
    const token = props.auth.user.accessToken;
    props.admin_delete_chain_catalog(token, id, onSuccess);
  };
  const [selectedSort, setSelectedSort] = useState(0);

  const sortByChangeCode = (id) => {
    setSelectedSort(id);
  };

  var filteredGlobalCatalog = props.allGLobalCatalog
    .sort((a, b) =>
      selectedSort === 0
        ? a.name.toLowerCase() > b.name.toLowerCase()
          ? 1
          : -1
        : b.name.toLowerCase() > a.name.toLowerCase()
        ? 1
        : -1
    )
    .filter((offer) => offer);

  filteredGlobalCatalog = filteredGlobalCatalog.filter((item) => {
    return (
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.description.toLowerCase().includes(search.toLowerCase())
    );
  });

  var filteredChainCatalog = props.allChainCatalog
    .sort((a, b) =>
      selectedSort === 0 ? (a.name > b.name ? 1 : -1) : b.name > a.name ? 1 : -1
    )
    .filter((offer) => offer);

  filteredChainCatalog = filteredChainCatalog.filter((item) => {
    return (
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.description.toLowerCase().includes(search.toLowerCase())
    );
  });

  const editData = (catalogData) => {
    const formData = catalogData;
    formData.edit = true;
    dispatch({ type: EDIT_GLOBAL_CATALOG, payload: formData });
    history.push("/superadmin-global-catalogue/add-catalogue");
  };

  const editChainData = (catalogData) => {
    const formData = catalogData;
    formData.edit = true;
    dispatch({ type: EDIT_CHAIN_CATALOG, payload: formData });
    history.push("/superadmin-chain-catalogue/add-catalogue");
  };

  // const takeToAddCatalogue = (data) => {
  //   dispatch({ type: GLOBAL_ADD_CATALOG_ACTIVE_DATA, payload: data });
  // };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.admin_get_global_catalog(token);
    props.admin_get_chain_catalog(token);
  }, []);

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <Container fluid>
          <div className="d-flex justify-content-between mt-3">
            <div className="f24-700">Catalogue Management</div>
            <div
              onClick={() => {
                if (state === 1) {
                  history.push("/superadmin-global-catalogue/add-catalogue");
                  let formData = { edit: false };
                  dispatch({ type: EDIT_GLOBAL_CATALOG, payload: formData });
                } else {
                  history.push("/superadmin-chain-catalogue/add-catalogue");

                  let formData = { edit: false };
                  dispatch({ type: EDIT_CHAIN_CATALOG, payload: formData });
                }
              }}
            >
              <button
                className="btn btn-md btn-danger"
                //onClick={() => takeToAddCatalog()}
              >
                + Create Catalogue
              </button>
            </div>
          </div>
          <div>
            <FilterSection
              sortByChangeCode={(id) => sortByChangeCode(id)}
              selectedSort={selectedSort}
              search={search}
              onChange={(e) => setSearch(e)}
            />
          </div>
          <div className="mt-3 d-flex">
            <div
              className={`mr-3 ${state === 1 && `selected-global-catalogue`}`}
              style={{ cursor: "pointer" }}
              onClick={() => {
                setState(1);
              }}
            >
              Global Catalogue Management
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={` ${state === 2 && `selected-global-catalogue`}`}
              onClick={() => {
                setState(2);
              }}
            >
              Chain Catalogue Management
            </div>
          </div>
          <div>
            <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
              <Table>
                <thead>
                  {state === 1 && <TableHead />}
                  {state === 2 && <ChainTablesHead />}
                </thead>
                {state === 1 && (
                  <TableBody
                    //takeToAddCatalogue={(data) => takeToAddCatalogue(data)}
                    editData={(catalogData) => editData(catalogData)}
                    data={filteredGlobalCatalog}
                    deleteGlobalCatalog={(id) => deleteGlobalCatalog(id)}
                    onChangeGlobalStatus={(status, id) =>
                      onChangeGlobalStatus(status, id)
                    }
                  />
                )}
                {state === 2 && (
                  <ChainTablesBody
                    editChainData={(catalogData) => editChainData(catalogData)}
                    data={filteredChainCatalog}
                    deleteChainCatalog={(id) => deleteChainCatalog(id)}
                    onChangeChainStatus={(status, id) =>
                      onChangeChainStatus(status, id)
                    }
                  />
                )}
              </Table>
            </div>
          </div>
        </Container>
      )}
    </React.Fragment>
  );
};

GlobalCatalogueDashboard.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allGLobalCatalog: state.commonSuperAdmin.allGLobalCatalog,
  allChainCatalog: state.commonSuperAdmin.allChainCatalog,
});

export default connect(mapStateToProps, {
  admin_get_global_catalog,
  admin_get_chain_catalog,
  admin_update_global_catalog,
  admin_delete_global_catalog,
  admin_delete_chain_catalog,
  admin_update_chain_catalog,
})(GlobalCatalogueDashboard);

const TableHead = (props) => {
  return (
    <tr>
      <th style={{ width: "9%" }}>Id</th>
      <th style={{ width: "10%" }}>
        Catalogue
        <br /> Name
      </th>
      <th style={{ width: "31%" }}>Description</th>
      <th style={{ width: "6%" }}>
        No. <br />
        Items
      </th>
      <th style={{ width: "8%" }}>Status</th>
      <th style={{ width: "14%" }}>
        Created Date &<br /> Time
      </th>
      <th style={{ width: "22%" }}>Actions</th>
    </tr>
  );
};

const TableBody = (props) => {
  return (
    <React.Fragment>
      {props &&
        props.data &&
        props.data.map((catalog, index) => (
          <tbody key={index}>
            <tr className="super_admin_all_users_table_body">
              <td className="text-break" style={{ width: "9%" }}>
                <div className="f14-500">#{catalog._id}</div>
              </td>
              <td className="text-break" style={{ width: "10%" }}>
                <div className="f15-500">{catalog.name}</div>
              </td>
              <td style={{ width: "31%" }}>
                <div className="f14-500">{catalog.description}</div>
              </td>
              <td style={{ width: "6%" }}>
                <NavLink
                  to={`/superadmin-global-catalogue/catalogue/${catalog._id}`}
                >
                  <div className="f15-500" style={{ color: "#2196F3" }}>
                    {catalog && catalog.items && catalog.items.length}
                  </div>
                </NavLink>
              </td>
              <td style={{ width: "8%" }}>
                <div className="f15-500">
                  <Switch
                    //onChange={() => {}}
                    onChange={() =>
                      props.onChangeGlobalStatus(catalog.status, catalog._id)
                    }
                    checked={catalog.status}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                  />
                </div>
              </td>
              <td style={{ width: "14%" }}>
                <div className="f14-500">
                  {moment(catalog.createdAt).format("Do MMMM YYYY, h:mm a")}
                </div>
              </td>
              <td style={{ width: "20%" }}>
                <div className="d-flex">
                  <GlobalCatalogViewDetails
                    name="Global"
                    data={catalog && catalog}
                    displayView={"GlobalCatalog"}
                    // types={props.type}
                    // catalog={catalog}
                  />

                  <div
                    className="enIconBtn mr-3"
                    onClick={() => props.editData(catalog)}
                    // to={`/superadminoffers/edit-admin-offline-offer/`}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit catalog"
                      title="Edit catalog"
                      fluid
                    />
                  </div>
                  <GlobalCatalogDeletePopUp
                    catalogId={catalog._id}
                    type="global"
                    title="Delete Catalogue"
                    subtitle="Are you sure you want to delete this catalogue?"
                    deleteGlobalCatalog={() =>
                      props.deleteGlobalCatalog(catalog._id)
                    }
                  />
                </div>
              </td>
            </tr>
          </tbody>
        ))}
    </React.Fragment>
  );
};
